// ============================================
// ЕДИНЫЙ ИСТОЧНИК ЦВЕТОВ ТЕМЫ
// ============================================
// ВАЖНО: Цвета должны быть синхронизированы с src/styles/_mixinsAndVariables.scss
// При изменении цветов обновляйте ОБА файла для консистентности

export const themeColors = {
  violet: {
    name: "Лавандовый",
    text: "#ffffff",
    accent: "#8372b2",
    hoveredText: "#c084fc",
    displayColor: "#c084fc"
  },
  green: {
    name: "Изумрудный",
    text: "#ffffff",
    accent: "#0f7e3a",
    hoveredText: "#81c784",
    displayColor: "#81c784"
  },
  blue: {
    name: "Морской",
    text: "#ffffff",
    accent: "#19808c",
    hoveredText: "#5080f2",
    displayColor: "#3faaff"
  },
  brown: {
    name: "Карамельный",
    text: "#ffffff",
    accent: "#733e1f",
    hoveredText: "#914f11",
    displayColor: "#b86b42"
  },
  pink: {
    name: "Bubblegum",
    text: "#ffffff",
    accent: "#fd599a",
    hoveredText: "#ff99c8",
    displayColor: "#ff99c8"
  },
  red: {
    name: "Гранатовый",
    text: "#ffffff",
    accent: "#a31414",
    hoveredText: "#c78181",
    displayColor: "#eb1b1bff"
  }
};

export type ThemeColor = keyof typeof themeColors;

export const isThemeColor = (value: string): value is ThemeColor =>
  Object.prototype.hasOwnProperty.call(themeColors, value);

export const getColorConfig = (colorName: string) => {
  return isThemeColor(colorName) ? themeColors[colorName] : themeColors.green;
};

export const getAllColorsArray = () => {
  return Object.entries(themeColors).map(([key, config]) => [
    key,
    config.displayColor,
    config.name
  ]);
};
